import { isLoadingSelector, isUpdatedSelector, errorSelector } from '../utils/helperSelectors';
const reducerName = 'userActivation';
export const isUserActivationLoadingSelector = isLoadingSelector(reducerName);
export const isUserActivationUpdatedSelector = isUpdatedSelector(reducerName);
export const userActivationErrorSelector = errorSelector(reducerName);
//# sourceMappingURL=selectors.js.map